module.exports = __webpack_public_path__ + "img/HomeRegularPlan-Icon.c4787452.svg";